export default function formatISODate(isoDate) {
    if (!isoDate) {
        return 'No data'
    }
    const date = new Date(isoDate);
    const options = { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit', 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit', 
        hour12: false, 
        timeZone: 'America/Santiago' 
    };
    const formattedDate = date.toLocaleString('en-GB', options);
    return formattedDate.replace(',', ' -');
}

// Espeja la política del user pool de Cognito. El orden es el que se muestra en
// pantalla, así que el usuario ve la lista siempre igual.
export const PASSWORD_RULES = [
    { id: 'length', label: 'Al menos 8 caracteres', test: (p) => p.length >= 8 },
    { id: 'uppercase', label: 'Una letra mayúscula', test: (p) => /[A-Z]/.test(p) },
    { id: 'lowercase', label: 'Una letra minúscula', test: (p) => /[a-z]/.test(p) },
    { id: 'number', label: 'Un número', test: (p) => /[0-9]/.test(p) },
    { id: 'special', label: 'Un carácter especial', test: (p) => /[\^$*.()[\]{}?!"!@#%&/\\,><':;|_~`+=-]/.test(p) },
];

/** Qué reglas cumple la contraseña, para pintar la lista mientras se escribe. */
export function getPasswordRuleStatus(password) {
    return PASSWORD_RULES.map((rule) => ({
        ...rule,
        met: rule.test(password || ''),
    }));
}

export function checkPasswordFormat(password) {
    // Antes no se comprobaba el número, aunque la pantalla lo pedía y Cognito lo
    // exige: la contraseña pasaba la validación local y el servidor la rechazaba.
    return PASSWORD_RULES.every((rule) => rule.test(password || ''));
}